var _g, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "campaign-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_687",
    "data-name": "Rectangle 687",
    width: 24,
    height: 24,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M18,11v2h4V11Z",
    fill: "#a0ce4e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M16,17.61c.96.71,2.21,1.65,3.2,2.39.4-.53.8-1.07,1.2-1.6-.99-.74-2.24-1.68-3.2-2.4C16.8,16.54,16.4,17.08,16,17.61Z",
    fill: "#a0ce4e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M20.4,5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24,1.68-3.2,2.4.4.53.8,1.07,1.2,1.6C18.16,7.28,19.41,6.35,20.4,5.6Z",
    fill: "#a0ce4e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M4,9a2.006,2.006,0,0,0-2,2v2a2.006,2.006,0,0,0,2,2H5v4H7V15H8l5,3V6L8,9Zm5.03,1.71L11,9.53v4.94L9.03,13.29,8.55,13H4V11H8.55Z",
    fill: "#a0ce4e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M15.5,12A4.48,4.48,0,0,0,14,8.65v6.69A4.442,4.442,0,0,0,15.5,12Z",
    fill: "#a0ce4e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/leftIcon.4a47098baf820611224562fde1c9800c.svg";
export { ForwardRef as ReactComponent };